import createClient from '@economic/http-client';

export { createJsonPatchOperation } from '@economic/http-client';

export const INTERNAL_API_URL = `${process.env.ECONOMIC_INTERNALAPI_PATH}/internal-api`;
export const INTERNAL_API_APP_TOKEN_URL = `${INTERNAL_API_URL}/application/token`;
export const INTERNAL_API_APP_ACCESS_TOKEN_URL = `${INTERNAL_API_URL}/application/access-token`;
export const INTERNAL_API_APP_ANTI_FORGERY_URL = `${INTERNAL_API_URL}/application/anti-forgery`;

export default createClient(INTERNAL_API_URL, INTERNAL_API_APP_TOKEN_URL);
